import { FormRow } from "@/features/forms/components/FormRow";
import { useFormPreviewOverlay } from "@/features/forms/hooks/useFormPreviewOverlay";
import { EmptyState } from "@/shared/components/ui/EmptyState";
import { ErrorState } from "@/shared/components/ui/ErrorState";
import { ItemList } from "@/shared/components/ui/ItemList";
import { RowSkeleton } from "@/shared/components/ui/RowSkeleton";
import { Section } from "@/shared/components/ui/Section";
import type { AppointmentForm } from "../types/appointmentFormTypes";

interface AppointmentFormsSectionProps {
  forms: AppointmentForm[];
  appointmentId?: string;
  savedForms?: AppointmentForm[];
  legacy?: boolean;
  isLoading?: boolean;
  error?: Error | null;
  onRetry?: () => void;
}

export function AppointmentFormsSection({ forms, appointmentId, savedForms = [], legacy, isLoading, error, onRetry }: AppointmentFormsSectionProps) {
  const { openPreview } = useFormPreviewOverlay();
  return (
    <Section title="Forms">
      {isLoading ? <RowSkeleton /> : error ? <ErrorState message={error.message} onRetry={onRetry} /> : legacy ? (
        <EmptyState message="Forms were not captured for this older appointment. Changing its services will resolve the applicable forms." />
      ) : !forms.length ? <EmptyState message="No forms apply to the selected services." /> : (
        <ItemList items={[...forms].sort((a, b) => a.sequenceOrder - b.sequenceOrder).map((form) => ({ ...form, id: form.formId }))}
          renderItem={(form) => <FormRow
            form={form}
            caption={`Required by ${form.services.map((service) => service.name).join(", ")}`}
            onPreview={() => openPreview(form.formId, savedForms.some((saved) => saved.formId === form.formId && saved.versionId === form.versionId) ? appointmentId : undefined, form.versionId)}
          />}
        />
      )}
    </Section>
  );
}
